/**
 * useEquipmentTypeDocuments — STORY-1306 slice D (type-editor docs-tab).
 * Read-only dokumentum-lista a pinnelt #407 Document-reuse kontraktusra.
 */

import { listEquipmentTypeDocuments, type EquipmentTypeDocument } from '@/api/equipment-types';
import { useQuery } from '@tanstack/react-query';

export function useEquipmentTypeDocuments(typeId: string | null): {
  documents: EquipmentTypeDocument[];
  isLoading: boolean;
  isError: boolean;
} {
  const query = useQuery({
    queryKey: ['equipment-types', typeId, 'documents'],
    queryFn: () => listEquipmentTypeDocuments(typeId as string),
    enabled: typeId !== null && typeId.length > 0,
  });
  return {
    documents: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
